/**
 * Service for managing banners
 */
(function(){
  angular.module('previewBannerModule').factory('edxPreviewBannerService', [
    'configuration',
    'edxPreviewBanners',
    '$log',
    'moment',
    previewBannerServiceFactory]);

  function previewBannerServiceFactory(configuration, previewBanners, $log, moment) {

    /**
     * Determine if the user has permanently closed the banner.
     *
     * @return {boolean}
     */
    function isBannerHidden() {
      return sessionStorage.getItem('userClosedNotification') === 'true';
    }

    /**
     * Find the best banner to display for a given customer
     *
     * @param banners List of banners
     * @param customer The customer
     * @return {*} Banner if one found
     */
    function findBestBannerForCustomer(customer) {
      return _.find(previewBanners, function(banner) {
        var startDate, endDate, now;

        if (!banner.enabled) {
          return false;
        }

        if (banner.restrictTo && !banner.restrictTo[getUserType(customer)]) {
          return false;
        }

        if (_.isFunction(banner.enabled) && !banner.enabled(customer)) {
          return false;
        }

        if (banner.startDate) {
          startDate = moment(banner.startDate);
          if (!startDate.isValid()) {
            $log.error('banner ID = ' + banner.id + '.  startDate could not be converted to date.  Banner will be disabled.');
            return false;
          }

          now = moment();
          if (now.isBefore(startDate)) {
            return false;
          }
        }

        if (banner.endDate) {
          endDate = moment(banner.endDate);
          if (!endDate.isValid()) {
            $log.error('banner ID = ' + banner.id + '.  endDate could not be converted to date.  Banner will be disabled.');
            return false;
          }

          now = moment();
          if (!now.isBefore(endDate)) {
            return false;
          }
        }

        return true;
      });
    }

    function getUserType(customer) {
      if (customer.isGuardian()) {
        return 'guardian';
      }

      if (customer.isTeacher()) {
        return 'teacher';
      }

      if (customer.isAdmin()) {
        return 'admin';
      }

      return '';
    }

    function isBannerEnabledForCustomer(customer) {
      // Workaround for issue with CS representatives accidentally clicking on banners on behalf of customers
      if (customer.impersonated_admin_id) {
        return false;
      }

      var isBannerAvailable = findBestBannerForCustomer(customer) !== undefined;
      return !isBannerHidden() && configuration.isTrue('application.preview_banner.show') && isBannerAvailable;
    }

    return {
      isBannerEnabledForCustomer: isBannerEnabledForCustomer,
      isBannerHidden: isBannerHidden,
      findBestBannerForCustomer: findBestBannerForCustomer,
      getUserType: getUserType
    };
  }
})();
